export enum ProductTypes {
  stat0OutOfStock = 0,
}
